import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setStepperDisable } from "../../redux/slices/userSlice";
import { showManualContextualLoader } from "../../utils/contextualLoaderTrigger";
import { useNavigate } from "react-router-dom";

export default function EmandateStatus() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // dispatch(setStepperDisable(false));
    const timer = setTimeout(() => {
      navigate("/emandate");
      // window.location.href = "/emandate";
    }, 2000);

    return () => clearTimeout(timer);
  }, [dispatch, navigate]);

  return <>{showManualContextualLoader("Please wait...", 2100)}</>;
}
